export default __webpack_public_path__ + "static/media/Ecommerce-header-Header.94bc5f49.png";